<template>
    <div>
        <vuestic-widget headerText="Aulas Teóricas">
            <form id="form_aulas">
                <input type="hidden" name="id_turma_teorica" :value="this.$route.params.idTurma">
                <div class="row">
                    <div class="col-sm-12">
                        <h4>Criar Aulas Teóricas</h4>
                    </div>
                </div>
                <div class="row">
                    <div id="aula" class="col-md-12">
                        <InputAulaTeorica></InputAulaTeorica>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <button title="Adicionar novo dia de aula" @click="addInput" type="button"
                        class="btn btn-primary btn-micro"><i class="fa fa-plus"></i></button>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12 text-center">
                        <button class="btn btn-secondary" id="btn_limpar" type="reset">Limpar</button>&nbsp;&nbsp;
                        <button class="btn btn-primary" id="btn_salvar" type="button" @click="salvaInformacoes">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </vuestic-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import TurmasController from './TurmasController'
import InputAulaTeorica from './InputAulaTeorica'


window._ = require('lodash')

export default {
  name: 'form-aula',
  components: {
      InputAulaTeorica
  },
  data(){
      return {
          i: 1
      }
  },
  methods: {
    salvaInformacoes(){
        TurmasController.storeAula()
    },
    addInput(){       
        var InputClass = Vue.extend(InputAulaTeorica);
        var newInput = new InputClass();

        newInput.addTag(++this.i);
        newInput.$mount();

        document.getElementById('aula').appendChild(newInput.$el);
    }
  }
}
</script>
